<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import Swal from "sweetalert2";
import { cloneDeep, groupBy } from "lodash";
import { required } from "vuelidate/lib/validators";
import ApiType from "@/components/modals/api-type.vue";
import ApiResourceLogs from "@/components/modals/api-resource-logs.vue";
import ApiLogs from "@/components/modals/api-logs.vue";
import BackLogModal from "@/components/modals/backlogs.vue";
import PrintOptions from "@/components/modals/print-options.vue";
import ImportPreplanning from "@/components/modals/import-preplanning.vue";
import ImportApi from "@/components/modals/import-api.vue";
import ProfileCropper from "@/components/modals/profile-cropper.vue";
import ResourceUpdate from "@/router/views/office/office-widgets/actual-resource-item.vue";
import CartItems from "@/router/views/office/office-widgets/cart-items.vue";
import OPCRView from "@/components/widgets/opcr-view.vue";
import ItemsView from "@/components/widgets/items-view.vue";

const greaterThanZero = (value) => value.replace(/,/g, "") > 0;
export default {
    page: {
        title: "Actual OPCR/Deliverables",
    },
    components: {
        Layout,
        PageHeader,
        ApiType,
        ApiResourceLogs,
        ApiLogs,
        BackLogModal,
        PrintOptions,
        ImportPreplanning,
        ImportApi,
        ProfileCropper,
        ResourceUpdate,
        CartItems,
        OPCRView,
        ItemsView
    },
    data() {
        return {
            title: this.$store.state.data.selectedCampus.isExternal ? "My Actual WFP" : "My Actual OPCR",
            submitted: false,
            items: [
                {
                    text: "Dashboards",
                    href: "/",
                },
                {
                    text: this.$store.state.data.selectedCampus.isExternal ? "My Actual WFPs" : "My Actual OPCRs",
                    active: true,
                },
            ],
            targetData: [],
            modalTitle: "",
            totalRows: 1,
            currentPage: 1,
            perPage: 5,
            pageOptions: [5, 10, 25, 50, 100],
            filter: null,
            filterOn: ['name'],
            sortBy: "notification",
            sortDesc: true,
            form: {
                id: 0,
                name: "",
                description: "",
                isCatchUp: false,
                apiTypeId: 0,
                scoreEfficiency: "",
                scoreQuality: "",
                scoreTimeliness: "",
                finalRemarks: "",
                catchUpPlans: "",
                isCompleted: false,
                dateCompleted: "",
            },
            indexSelected: -1,
            tableBusy: false,
            apiType: "",
            cycle: "",
            itemList: [],
            perPageItem: 1,
            currentPageItem: 1,
            filterItem: "",
            filterIndicatorItem: "",
            loadItems: false,
            selectedItem: 0,
            selectedApi: {},
            selectedApiId: 0,
            budgetItem: "",
            ppmpIndex: -1,
            apiName: "",
            //budget
            filterBudget: "",
            budgetData: [],
            budgetBusy: false,
            selectedBudgetAmount: 0,
            item: {
                id: 0,
                itemName: "",
                description: "",
                unitId: "",
                type: "NON-CSE",
                itemCategoryId: "",
                unitCost: "0",
                cseId: 0,
                apiId: 0,
                deliveryUnitBudgetItemId: 0,
                isProcurable: true,
                isMixed: false,
            },

            // resource items
            itemLoading: false,
            resourceItems: [],
            itemIndex: -1,
            itemCategory: null,
            unit: "",

            previousWork: {},

            uploadOptions: {
                type: "API",
                placement: "lefttop",
                folder: "Planning",
            },
            subType: "Goods",
            budgetCopy: 0,
            groupedBudget: [],
            selectedTransfer: {},
            budgetVirtual: 0,
            profileTobeUpdated: null,
            resourceIndex: null,

            itemOption: 0,
            isActive: false,
            visibilityOff: 0,
            packages: [],
            packageItems: [],
            selectedPackage: null,
            slideBLI: false,
            bliBtn: "",
            showBLIBtn: false,
            selectedBLI: null,
            viewAll: false,
            accountCategories: [],
            openModal: false,
            lastConsumed: null,
            transferBudget: false,
            goodError: false,
            inflationRate: null,
            packageItemIndex: 0,
            navigation: null,
            showBLIScreen: false,
            carouselStyle: '',
            hubConnector: null,
            importFromPrep: false,
            currentPageResource: 1,
            perPageResource: 5,
            isExternal: false,
            createMix: false,
            showOPCR: false,
            opcrs: [],
            searchOPCR: '',
            loadOpcrs: false,
            selectedOPCR: null,
            showTarget: false,
            selectedTarget: null,
            listMode: 'opcr',
            selectAllAPI: true,
            startTransferAPI: false,
            startTransferChecking: false,
            frontPage: true,
            budgetTransferModal: false,
            selectedApiCopy: null,
            itemToTransfer: null,
            motherID: null,
            selectedAllTarget: null,
            carts: [],
            startSelection: false,
            selectedItems: []
        };
    },
    validations: {
        form: {
            name: { required },
            // description: { required },
            // apiTypeId: { required },
        },
        previousWork: {
            name: { required },
        },
        item: {
            itemName: { required },
            description: { required },
            unitId: { required },
            type: { required },
            itemCategoryId: { required },
            unitCost: { required, greaterThanZero },
        },
        detail: {
            month: { required },
            quantity: { required, greaterThanZero },
        },
        subType: { required },
        motherID: { required },
    },
    watch: {
        $route(to, from) {
            if (this.$route.params.id && this.$route.params.type === 'resource') {
                this.getApiByResource(this.$route.params.id);
            }
        }
    },
    computed: {
        rows() {
            if (this.filter) {
                return this.totalRows;
            }
            return this.targetData.length;
        },
        filteredOPCRs() {
            let data = this.opcrs;
            if (this.searchOPCR.trim() != "" && this.searchOPCR) {
                data = data.filter((item) => {
                    return item.title
                        .toUpperCase()
                        .includes(this.searchOPCR.toUpperCase());
                });
            }
            return data;
        },
        filteredResourceItems() {
            let data = this.resourceItems;
            var total = this.currentPageResource * this.perPageResource;
            if (this.filterChildParent == 1) {
                data = data.filter((item) => {
                    return item.mixParentId == 0 || item.mixParentId == null;
                });
            }
            if (this.filterChildParent == 2) {
                data = data.filter((item) => {
                    return item.mixParentId > 0;
                });
            }
            if (this.filterItem.trim() != "" && this.filterItem) {
                data = data.filter((item) => {
                    return item.itemName
                        .toUpperCase()
                        .includes(this.filterItem.toUpperCase());
                });
            }
            var currentData = data.slice(total - this.perPageResource, total);
            if (this.currentPageResource > 1 && currentData.length == 0) {
                total = (this.currentPageResource - 1) * this.perPageResource;
                currentData = data.slice(total - this.perPageResource, total);
            }
            return currentData;
        },
        rowsResourceItem() {
            let data = this.resourceItems;
            if (this.filterChildParent == 1) {
                data = data.filter((item) => {
                    return item.mixParentId == 0;
                });
            }
            if (this.filterChildParent == 2) {
                data = data.filter((item) => {
                    return item.mixParentId > 0;
                });
            }
            if (this.filterItem.trim() != "" && this.filterItem) {
                data = data.filter((item) => {
                    return item.itemName
                        .toUpperCase()
                        .includes(this.filterItem.toUpperCase());
                });
            }
            return data.length;
        },
        itemNamesFromSelected() {
            let names = this.selectedItems.map(item => item.itemName);
            return names.join(' | ');
        }
    },
    created() {
        this.totalRows = this.items.length;
        this.$store
            .dispatch("month/GetAllMonths")
            .then((res) => {
                this.months = res.data;
            })
            .catch(() => {
                this.showToast("Something went wrong!", "error");
            });
        this.$store
            .dispatch(
                "settings/GetInflationRate")
            .then((res) => {
                this.inflationRate = res.data;
            })
            .catch(() => {
                this.showToast("Something went wrong!", "error");
            });
        this.changeCycle(this.$store.state.data.cycle, true);
        this.getCartItems(this.$store.state.data.selectedDU.id);
    },
    beforeMount() {
        window.addEventListener("beforeunload", event => {
            if (!this.openModal) return
            event.preventDefault()
            event.returnValue = ""
        })
    },
    methods: {
        async getCartItems(id) {
            await this.$store
                .dispatch("deliveryunititemcart/GetDeliveryUnitItemCartByDU", id)
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    res.data.map(item => {
                        item.filterKey = `${item.item.itemName} ${item.item.description}`;
                    })
                    this.carts = res.data;
                })
                .catch(() => {
                    this.showToast("Something went wrong!", "error");
                });
        },
        totalResourceItemAmt() {
            var data = this.resourceItems;
            var sum = 0;
            data.forEach((item) => {
                if (!item.mixParentId) {
                    sum += parseFloat(item.totalWithInflation);
                }
            });
            return sum;
        },
        addApi(target) {
            if (target) {
                this.selectedItem = target.targetId;
                this.selectedAllTarget = target;
                this.selectedTarget = this.itemList.find(x => x.id == target.targetId);
            }
            this.onReset();
            this.modalTitle = "Create New API";
            this.$bvModal.show("modal-standard");
        },
        onCreate() {
            this.submitted = true;
            this.$v.form.$touch();
            if (this.$v.form.$invalid) {
                return;
            }
            if (this.form.isCatchUp) {
                this.$v.previousWork.$touch();
                if (this.$v.previousWork.$invalid) {
                    return;
                }
            } else {
                this.$v.previousWork.$reset();
            }
            var data = cloneDeep(this.form);
            data.dateCompleted = data.isCompleted ? this.getDate(this.form.dateCompleted) : this.getDate(new Date());
            // if(!this.selectAllAPI){
            data.targetId = this.selectedItem;
            data.opcrId = this.selectedOPCR.id;
            // }
            if (this.form.id > 0) {
                this.$store
                    .dispatch("api/UpdateApi", data)
                    .then((res) => {
                        if (res.data.error) {
                            return this.showToast(res.data.errorMessage, "error");
                        }
                        if (this.selectAllAPI) {
                            let index = this.selectedAllTarget.apis.findIndex(x => x.id == this.form.id);
                            data.filterKey = `${this.selectedAllTarget.target} ${data.name}`
                            this.selectedAllTarget.apis.splice(index, 1, data);
                        } else {
                            res.data.total = data.totalResources;
                            res.data.totalCurrency = this.formatCurrency(data.totalResources);
                            this.targetData.splice(this.indexSelected, 1, res.data);
                        }
                        this.$bvModal.hide("modal-standard");
                        this.showToast("Successfully updated!", "success");
                    })
                    .catch((err) => {
                        this.showToast("Something went wrong!", "error");
                    });
            } else {
                this.$store
                    .dispatch("api/CreateApi", data)
                    .then((res) => {
                        if (res.data.error) {
                            return this.showToast(res.data.errorMessage, "error");
                        }
                        res.data.showAttachments = false;
                        res.data.attachmentLoading = false;
                        res.data.addDocu = false;
                        res.data.fileSearch = "";
                        res.data.attachments = [];
                        if (this.selectAllAPI) {
                            res.data.filterKey = `${this.selectedAllTarget.target} ${res.data.name}`
                            this.selectedAllTarget.apis.push(res.data);
                        } else {
                            res.data.totalCurrency = this.formatCurrency(0);
                            this.targetData.push(res.data);
                        }
                        this.$bvModal.hide("modal-standard");
                        this.showToast("Successfully created!", "success");
                    })
                    .catch(() => {
                        this.showToast("Something went wrong!", "error");
                    });
            }
            this.submitted = false;
        },
        onReset() {
            this.form = {
                id: 0,
                name: "",
                description: "",
                isCatchUp: false,
                apiTypeId: 0,
                catchUpPlans: "",
                finalRemarks: "",
            };
            this.apiType = "";
            this.$v.form.$reset();
            this.$v.previousWork.$reset();
        },
        hideModal() {
            this.$bvModal.hide("modal-standard");
        },
        updateItem(props) {
            this.form = cloneDeep(props.item);
            this.form.dateCompleted = new Date(props.item.dateCompleted);
            this.apiType = props.item.apiType.type;
            this.indexSelected = this.targetData.indexOf(props.item);
            this.$v.form.$reset();
            this.$v.previousWork.$reset();
            this.modalTitle = "Update Api";
            this.$bvModal.show("modal-standard");
        },
        updateItemAll({ row: props, parent }) {
            this.selectedAllTarget = parent;
            this.form = cloneDeep(props);
            this.selectedItem = props.targetId;
            this.form.apiTypeId = 0;
            this.$v.form.$reset();
            this.$v.previousWork.$reset();
            this.modalTitle = "Update Api";
            this.$bvModal.show("modal-standard");
        },
        deleteItem(props) {
            var index = this.targetData.indexOf(props.item);
            Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#dc3545",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, delete it!",
            }).then((result) => {
                if (result.value) {
                    this.$store
                        .dispatch("api/DeleteApi", props.item.id)
                        .then((res) => {
                            if (res.status == 204) {
                                this.targetData.splice(index, 1);
                                this.$store.dispatch("filemanager/DeleteFileByReference", { referenceId: props.item.id, type: "API" })
                                this.showToast("Successfully deleted!", "success");
                            }
                        })
                        .catch(() => {
                            this.showToast("Cannot be deleted!", "error");
                        });
                }
            });
        },
        deleteItemAll({ row, parent }) {
            Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#dc3545",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, delete it!",
            }).then((result) => {
                if (result.value) {
                    this.$store
                        .dispatch("api/DeleteApi", row.id)
                        .then((res) => {
                            if (res.data.error) {
                                return this.showToast(res.data.errorMessage, "error");
                            }
                            let index = parent.apis.findIndex(x => x.id == row.id);
                            parent.apis.splice(index, 1);
                            this.showToast("Successfully deleted!", "success");
                        })
                        .catch((err) => {
                            console.log(err)
                            this.showToast("Cannot be deleted!", "error");
                        });
                }
            });
        },
        postPPMP(row) {
            Swal.fire({
                title: "Are you sure?",
                text: "You want to post this?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: "Yes, post it!",
            }).then(async (result) => {
                if (result.value) {
                    this.$store
                        .dispatch("api/PostApi", row.id)
                        .then((res) => {
                            if (res.data.error) {
                                return this.showToast(res.data.errorMessage, "warning");
                            }
                            row.status = "Posted";
                            this.showToast("Successfully posted!", "success");
                        })
                        .catch((err) => {
                            this.showToast("Something went wrong!", "error");
                        });
                }
            });
        },
        postWork() {
            Swal.fire({
                title: "Are you sure?",
                text: "You want to post this?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: "Yes, post it!",
            }).then(async (result) => {
                if (result.value) {
                    this.$store
                        .dispatch("api/PostApi", this.selectedApiId)
                        .then((res) => {
                            if (res.data.error) {
                                return this.showToast(res.data.errorMessage, "warning");
                            }
                            this.selectedApi.status = "POSTED";
                            this.targetData[this.apiIndex].status = "Posted";
                            this.showToast("Successfully posted!", "success");
                            this.frontPage = true;
                        })
                        .catch((err) => {
                            this.showToast("Something went wrong!", "error");
                        });
                }
            });
        },
        getApiType() {
            this.$bvModal.show("api-type-modal");
        },
        dropType(data) {
            this.apiType = data.type;
            this.form.apiTypeId = data.id;
        },
        async changeCycle(cycle, created = false) {
            if (!created) {
                this.frontPage = true;
            }
            this.resetSelection();
            this.pageLoader(true);
            await this.getMyOpcrs(cycle, this.$store.state.data.selectedDU.id);
            this.pageLoader(false);
            this.getMyTargets(cycle, this.$store.state.data.selectedDU.id);
        },
        resetSelection() {
            this.selectedOPCR = null;
            this.selectedTarget = null;
            this.selectedItem = 0;
            this.selectAllAPI = false;
            this.targetData = [];
        },
        async getMyOpcrs(cycle, deliveryUnitId) {
            this.opcrs = [];
            this.loadOpcrs = true;
            await this.$store
                .dispatch("opcr/GetAllOpcr", { cycle, deliveryUnitId })
                .then((res) => {
                    if (res.data.error) {
                        this.loadOpcrs = false;
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    this.opcrs = res.data;
                    if (this.opcrs.length > 0) {
                        this.selectedOPCR = this.opcrs[0];
                        this.getAllAPI()
                    }
                })
                .catch(() => {
                    this.showToast("Getting Opcrs Failed", "error");
                });
            this.loadOpcrs = false
        },
        async getApiByResource(id) {
            this.pageLoader(true);
            const { data } = await this.$store.dispatch('apiresource/GetSinglePPMPItem', id);
            const apiInfo = await this.$store.dispatch('api/GetSingleApi', data.apiId);
            let targetIndex = this.itemList.findIndex(item => item.id == apiInfo.data.targetId);
            if (targetIndex < 0) {
                this.pageLoader(false);
                return this.showToast('Target not found', 'error');
            }
            await this.selectIndicatorItem(this.itemList[targetIndex]);
            await this.goToPPMP(apiInfo.data);
            let resourceIndex = this.resourceItems.findIndex(item => item.id == data.id);
            if (resourceIndex < 0) {
                this.pageLoader(false);
                return this.showToast('API Resource not found', 'error');
            }
            let currentPage = Math.floor(resourceIndex / this.perPageResource);
            this.currentPageResource = currentPage + 1;
            this.$nextTick(() => {
                this.$refs[`resource-tr-${id}`][0].classList.add('resource-bg');
                setTimeout(() => {
                    var top = this.$refs[`resource-tr-${id}`][0].offsetTop;
                    window.scrollTo(0, top);
                }, 300)
            })
            this.pageLoader(false);
        },
        async selectIndicatorItem(row, type = false) {
            this.selectedItem = row.id;
            this.apiName = row.description;
            this.selectedTarget = row;
            this.showTarget = false;
            this.selectAllAPI = false;
            this.getAPIbyOPCRandTarget();
        },
        getAPIbyOPCRandTarget() {
            if (!this.selectedTarget) {
                return;
            }
            this.tableBusy = true;
            this.$store
                .dispatch("api/GetApiByTarget", { targetId: this.selectedTarget.id, opcrId: this.selectedOPCR.id })
                .then((res) => {
                    this.tableBusy = false;
                    if (res.data) {
                        res.data.forEach((item) => {
                            item.showAttachments = false;
                            item.attachmentLoading = false;
                            item.addDocu = false;
                            item.fileSearch = "";
                            item.attachments = [];
                            item.totalCurrency = this.formatCurrency(
                                item.totalResources
                            );
                        });
                        this.targetData = res.data;
                    } else {
                        this.targetData = [];
                    }
                })
                .catch(() => {
                    this.tableBusy = false;
                    this.showToast("Something went wrong!", "error");
                });
        },
        async goToPPMP(row) {
            this.selectedApi = row;
            this.selectedApiId = row.id;
            this.selectedApi.status = row.status.toUpperCase();
            this.selectedApiCopy = cloneDeep(row);
            this.apiIndex = this.targetData.indexOf(row);
            this.title = "Office Budget Line Items";
            this.frontPage = false;
            this.scrollToTop();
            this.itemLoading = true;
            this.resourceItems = [];
            await this.$refs['resource-update'].getAllBudgets();
            await this.getResourceDetails(row.id);
        },
        async goToPPMPAll({ row, parent }) {
            this.selectedAllTarget = parent;
            this.selectedApi = row;
            this.selectedApiId = row.id;
            this.selectedApi.status = row.status.toUpperCase();
            this.selectedApiCopy = cloneDeep(row);
            this.title = "Office Budget Line Items";
            this.frontPage = false;
            this.scrollToTop();
            this.itemLoading = true;
            this.resourceItems = [];
            await this.$refs['resource-update'].getAllBudgets();
            await this.getResourceDetails(row.id);
        },
        returnToApi() {
            this.title = "My OPCR";
            this.frontPage = true;
        },
        async getResourceDetails(id) {
            await this.$store
                .dispatch("apiresource/GetAllResourceByAPI", id)
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    let resourceItems = [];
                    res.data.map((item) => {
                        let budgetInfo = this.$refs['resource-update'].budgetData.find(
                            (x) => x.deliveryUnitBudgetItemId == item.deliveryUnitBudgetItemId
                        );
                        item.selected = false;
                        item.deliveryUnitBudgetItem = {
                            fundSource: budgetInfo.fundSource,
                            fundClass: budgetInfo.fundClass,
                            accountGroup: budgetInfo.accountGroup,
                            accountGroupId: budgetInfo.accountGroupId,
                        };
                        item.thumbnailUrl = item.thumbnail
                            ? `${this.$store.state.data.rootFileDirectory}Procurement/${item.thumbnail}`
                            : "";
                        item.apiTransferId = 0;
                        if (item.mixParentId && item.mixParentId > 0) {
                            let parent = res.data.find(x => x.id == item.mixParentId);
                            if (parent) {
                                item.mixParentItemName = parent.itemName;
                                item.filterKey = `${item.itemName} ${item.description} ${parent.itemName}`;
                            }
                        }
                        if (!item.mixParentId || item.mixParentId == 0) {
                            let kids = res.data.filter(kid => kid.mixParentId == item.id);
                            item.kids = kids.map(k => k.id);
                            item.filterKey = `${item.itemName} ${item.description} ${kids.map(k => `${k.itemName} ${k.description}`).join(' ')}`;
                            resourceItems.push(item);
                            for (const kid of kids) {
                                resourceItems.push(kid);
                            }
                        }
                        item.showRow = true;
                        item.showChild = true;
                    });
                    this.resourceItems = resourceItems;
                    this.itemLoading = false;
                })
                .catch((err) => {
                    this.itemLoading = false;
                    this.showToast("Something went wrong!", "error");
                });
        },
        deleteResourceItem(props) {
            var index = this.resourceItems.indexOf(props);
            var budgetIndex = this.$refs['resource-update'].budgetData.findIndex((x) => x.deliveryUnitBudgetItemId == props.deliveryUnitBudgetItemId);
            var apiIndex = -1;
            if (this.selectAllAPI) {
                apiIndex = this.selectedAllTarget.apis.findIndex(x => x.id == props.apiId);
            } else {
                apiIndex = this.targetData.findIndex(x => x.id == props.apiId);
            }
            Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#dc3545",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, delete it!",
            }).then((result) => {
                if (result.value) {
                    this.$store
                        .dispatch("apiresource/DeletePPMPItem", props.id)
                        .then((res) => {
                            if (res.data.error) {
                                return this.showToast(res.data.errorMessage, "error");
                            }
                            this.resourceItems.splice(index, 1);
                            if (props.mixParentId > 0) {
                                this.resourceItems.find((e) => e.id == props.mixParentId).remaining += props.totalWithInflation;
                            } else {
                                if (this.selectAllAPI) {
                                    this.selectedAllTarget.apis[apiIndex].totalResources = cloneDeep(this.totalResourceItemAmt());
                                } else {
                                    this.targetData[apiIndex].totalResources = cloneDeep(this.totalResourceItemAmt())
                                    this.targetData[apiIndex].totalCurrency = this.formatCurrency(this.targetData[apiIndex].totalResources);
                                }
                                this.$refs['resource-update'].budgetData[budgetIndex].balance += props.totalWithInflation;
                                this.$refs['resource-update'].budgetData[budgetIndex].totalResources -= props.totalWithInflation;
                                // this.$refs['resource-update'].budgetData[budgetIndex].resourceCount--;
                            }
                            this.showToast("Successfully deleted!", "success");
                        })
                        .catch((err) => {
                            this.showToast("Cannot be deleted!", "error");
                        });
                }
            });
        },
        viewItemLogs({ id }) {
            this.$refs.itemlog.getData(id);
            this.$bvModal.show("api-resoure-log-modal");
        },
        viewApiLogs(id) {
            this.$refs.apilog.getData(id);
            this.$bvModal.show("api-log-modal");
        },
        resubmitItem(x) {
            Swal.fire({
                title: "Are you sure?",
                text: "You want to resubmit this?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: "Yes, resubmit it!",
            }).then(async (result) => {
                if (result.value) {
                    this.$store
                        .dispatch("apiresource/ResubmitPPMPItem", x.id)
                        .then((res) => {
                            if (res.data.error) {
                                return this.showToast(res.data.errorMessage, "error");
                            }
                            x.technicalReviewStatus = "PENDING";
                            this.showToast("Successfully resubmitted!", "success");
                        })
                        .catch((err) => {
                            console.log(err)
                            this.showToast("Something went wrong!", "error");
                        });
                }
            });
        },
        async updateResourceItem({ props, type }) {
            this.pageLoader(true);
            this.budgetTransferModal = false;
            this.$refs['resource-update'].getItemInfo(props, type);
            this.pageLoader(false);
        },
        async updateMixResourceItem(props) {
            this.pageLoader(true);
            this.budgetTransferModal = false;
            let parent = this.resourceItems.find(x => x.id == props.mixParentId);
            this.$refs['resource-update'].updateMixItem(props, parent);
            this.pageLoader(false);
        },
        getWork() {
            this.$refs.backlog.getData();
            this.$bvModal.show("backlog-modal");
        },
        dropWork(data) {
            this.previousWork = cloneDeep(data);
            this.form.apiId = data.id;
        },
        showDtls(row) {
            if (row.item.showAttachments) {
                row.item.showAttachments = !row.item.showAttachments;
                setTimeout(() => {
                    row.toggleDetails();
                }, 600);
            } else {
                this.getAttachments(row.item);
                row.toggleDetails();
                setTimeout(() => {
                    row.item.showAttachments = !row.item.showAttachments;
                }, 50);
            }
        },
        getAttachments(row) {
            row.attachmentLoading = true;
            row.attachments = [];
            this.$store
                .dispatch("filemanager/GetFiles", {
                    id: row.id,
                    type: this.uploadOptions.type,
                })
                .then((res) => {
                    row.attachmentLoading = false;
                    row.attachments = res.data;
                })
                .catch(() => {
                    row.attachmentLoading = false;
                    this.showToast(
                        "Something went wrong! - getting documents",
                        "error"
                    );
                });
        },
        removeFile(id, parentId) {
            Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#dc3545",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, remove it!",
            }).then((result) => {
                if (result.value) {
                    this.$store
                        .dispatch("filemanager/DeleteFile", id)
                        .then((res) => {
                            if (res.data.error) {
                                return this.showToast(
                                    res.data.errorMessage,
                                    "error"
                                );
                            }
                            let index = this.targetData.findIndex(
                                (item) => item.id == parentId
                            );
                            let yIndex = this.targetData[
                                index
                            ].attachments.findIndex((item) => item.id == id);
                            this.targetData[index].attachments.splice(
                                yIndex,
                                1
                            );
                            this.showToast("Successfully removed!", "success");
                        })
                        .catch(() => {
                            this.showToast("Cannot be removed!", "error");
                        });
                }
            });
        },
        uploadedDocument({ response, id }) {
            let index = this.targetData.findIndex((item) => item.id == id);
            this.targetData[index].attachments.push(response);
        },
        openDocument(x) {
            this.readFile(x.id)
        },
        async printOPCR(type) {
            let apiUrl = "api/Report/Planning/DU/OPCR";
            if (type == 4) {
                apiUrl = "api/Report/Planning/OPCR/V4";
            }
            this.$refs.printOpt.putOptions({
                apiUrl: apiUrl,
                routeVariables: [this.selectedOPCR.id],
            });
            this.$bvModal.show("print-options-modal");
        },
        async printWFP() {
            this.$refs.printOpt.putOptions({
                apiUrl: "api/Report/PrePlanning/WFP",
                routeVariables: [this.$store.state.data.cycle, this.$store.state.data.selectedDU.id],
            });
            this.$bvModal.show("print-options-modal");
        },
        async printDULIB() {
            this.$refs.printOpt.putOptions({
                apiUrl: "api/Report/Planning/LIB/OPCR",
                routeVariables: [this.selectedOPCR.id],
            });
            this.$bvModal.show("print-options-modal");
        },
        transferItem(arr) {
            this.selectedTransfer = cloneDeep(arr[0]);
            this.selectedItems = arr;
            this.frontPage = true;
        },
        cancelTransfer() {
            this.frontPage = true;
            this.selectedTransfer = {};
            this.selectedItems = [];
        },
        importNewItem() {
            this.importFromPrep = true;
            // this.openBLI();
        },
        dropImports(event) {
            let ids = [];
            let sum = 0;
            event.forEach((item) => {
                ids.push(item.id);
                sum = sum + parseFloat(item.total);
            });
            let data = {
                deliveryUnitBudgetItemId: this.selectedBLI.id,
                apiId: this.selectedApiId,
                apiResourceIds: ids,
            };
            this.$store
                .dispatch("apiresource/ImportResource", data)
                .then(async (res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    this.$bvModal.hide("preplanning-modal");
                    this.importFromPrep = false;
                    this.itemLoading = true;
                    this.resourceItems = [];
                    await this.getResourceDetails(this.selectedApiId);
                    this.budgetCopy -= sum;
                    this.budgetData[this.budgetIndex].balance -= sum;
                    this.budgetData[this.budgetIndex].totalWithInflation += sum;
                    this.closeAdding();
                    this.showToast("Successfully imported!", "success");
                })
                .catch(() => {
                    this.showToast(
                        "Something went wrong in importing!",
                        "error"
                    );
                });
        },
        importApi() {
            this.$refs.importapi.getData();
            this.$bvModal.show("import-api-modal");
        },
        dropImportedApi(event) {
            let data = {
                targetId: this.selectedItem,
                prePlanningApiIds: [],
            };
            event.forEach((item) => {
                data.prePlanningApiIds.push(item.id);
            });
            this.$store
                .dispatch("api/ImportPreplanningApi", data)
                .then(async (res) => {
                    this.$bvModal.hide("import-api-modal");
                    let index = this.itemList.findIndex(
                        (item) => item.id == this.selectedItem
                    );
                    this.selectIndicatorItem(this.itemList[index], true);
                })
                .catch((err) => {
                    this.showToast(
                        "Something went wrong in importing!",
                        "error"
                    );
                });
        },
        updateProfile(row) {
            this.resourceIndex = this.resourceItems.indexOf(row);
            this.profileTobeUpdated = row;
            this.modalTitle = "Update Profile";
            this.$bvModal.show("upload-profile");
            this.$refs.profileCropper.resetData();
            if (row.image) {
                this.$refs.profileCropper.updateProfile = true;
                this.$refs.profileCropper.imageUrl = `${this.$store.state.data.rootFileDirectory}Procurement/${row.image}`;
                this.$refs.profileCropper.showCropBtn = true;
            } else {
                this.$refs.profileCropper.updateProfile = false;
                this.$refs.profileCropper.imageUrl = "";
            }
        },
        async cropData(event) {
            let updateProfile = await this.updateApiResourceImg(event, this.profileTobeUpdated);
            if (updateProfile.success) {
                this.resourceItems[this.resourceIndex].image = updateProfile.data.image;
                this.resourceItems[this.resourceIndex].thumbnail = updateProfile.data.thumbnail;
                this.resourceItems[
                    this.resourceIndex
                ].thumbnailUrl = `${this.$store.state.data.rootFileDirectory}Procurement/${updateProfile.data.thumbnail}`;
                this.$bvModal.hide("upload-profile");
                this.showToast("Successfully uploaded!", "success");
            } else {
                this.showToast(updateProfile.data, "error");
            }
        },

        closeAdding() {
            document.body.classList.remove('resource-open');
            this.slideBLI = false;
            this.showBLIBtn = false;
            this.viewAll = false;
            this.isActive = false;
            this.visibilityOff = 0;
            this.itemOption = 0;
            this.optionStyle =
                "top:50%;left:50%;transform:translate(-50%,-50%);";
            this.openModal = false;
            this.selectedBLI = null;
            this.budgetIndex = -1;
            this.budgetCopy = 0;
            this.selectedBudgetAmount = 0;
            this.budgetVirtual = 0;
        },
        getFundSourceTotal(row) {
            let total = 0;
            row.data.forEach((x) => {
                x.data.forEach((y) => {
                    y.data.forEach((z) => {
                        total += z.totalWithInflation;
                    });
                });
            });
            return total;
        },
        getFundSourceBalance(row) {
            let balance = 0;
            row.data.forEach((x) => {
                x.data.forEach((y) => {
                    y.data.forEach((z) => {
                        balance += z.balance;
                    });
                });
            });
            return balance;
        },
        notifyForUpdates(row) {
            this.$store
                .dispatch("apiresource/TraceItem", {
                    id: row.id,
                    IsNotify: !row.notify,
                })
                .then((res) => {
                    this.showToast("Successfully set!", "success");
                })
                .catch((err) => {
                    this.showToast("Something went wrong!", "error");
                });
        },
        transferIfs(row) {
            if (this.selectedTransfer.id) {
                if (this.selectedTransfer.deliveryUnitBudgetItem.accountGroupId == row.accountGroupId) {
                    return true;
                }
                return false;
            } else {
                if (this.item.id > 0) {
                    if (this.item.deliveryUnitBudgetItem.accountGroupId == row.accountGroupId) {
                        if (row.id == (this.selectedBLI && this.selectedBLI.id)) {
                            return false;
                        }
                        return true;
                    }
                    return false;
                }
                return false;
            }
        },
        async selectTransferApi({ row }) {
            let errors = 0;
            this.selectedTransfer.apiTransferId = row.id;
            for await (const item of this.selectedItems) {
                item.apiTransferId = row.id;
                let data = {
                    deliveryUnitBudgetItemId: item.deliveryUnitBudgetItemId,
                    apiResourceId: item.id,
                    apiId: row.id,
                }
                this.$store
                    .dispatch("apiresource/TransferResource", data)
                    .then((res) => {
                        if (res.data.error) {
                            errors++;
                            return this.showToast(res.data.errorMessage, "error");
                        }
                        if (this.selectAllAPI) {
                            row.total += parseFloat(item.total);
                            row.totalResources = this.formatCurrency(row.total);
                            this.targetData.map(x => {
                                let api = x.apis.find((e) => e.id == x.apiId);
                                if (api) {
                                    api.total -= parseFloat(x.total);
                                    api.totalResources = this.formatCurrency(api.total);
                                }
                            })
                        } else {
                            row.totalResources += parseFloat(item.total);
                            row.totalCurrency = this.formatCurrency(row.totalResources);
                            let index = this.targetData.findIndex((e) => e.id === item.apiId);
                            if (index > -1) {
                                this.targetData[index].totalResources -= parseFloat(item.total);
                                this.targetData[index].totalCurrency = this.formatCurrency(this.targetData[index].totalResources);
                            }
                        }

                    })
                    .catch((err) => {
                        errors++;

                    });
            }
            if (errors > 0) {
                return this.showToast("Something went wrong", "error");
            }
            this.cancelTransfer();
            this.showToast("Successfully transferred!", "success");

            // this.openBLI();
        },
        showPackageModal() {
            this.$refs.pckModal.getData();
            this.$bvModal.show("package-modal");
        },
        async changeDU(du) {
            this.frontPage = true;
            this.title = du.isExternal ? "My Actual WFP" : "My Actual OPCR",
                this.items = [
                    {
                        text: "Dashboards",
                        href: "/",
                    },
                    {
                        text: du.isExternal ? "My Actual WFPs" : "My Actual OPCRs",
                        active: true,
                    },
                ],
                this.resetSelection();
            this.pageLoader(true);
            await this.getMyOpcrs(this.$store.state.data.cycle, du.id);
            this.pageLoader(false);
            this.getMyTargets(this.$store.state.data.cycle, du.id);
            this.selectAllAPI = false;
        },
        getMyTargets(cycle, deliveryUnitId) {
            this.$store
                .dispatch("target/GetMyTarget", { cycle, deliveryUnitId })
                .then((res) => {
                    this.loadItems = false;
                    res.data.forEach((item) => {
                        item.actualQ1 = item.actual.length > 0 ? item.actual[0].q1 : "0";
                        item.actualQ2 = item.actual.length > 0 ? item.actual[0].q2 : "0";
                        item.actualQ3 = item.actual.length > 0 ? item.actual[0].q3 : "0";
                        item.actualQ4 = item.actual.length > 0 ? item.actual[0].q4 : "0";
                        item.searchList = `${item.remarks} ${item.mainTarget.indicatorItem.indicatorItemName}`;
                        item.prexC = item.mainTarget.indicatorItem.indicator.prexc.prexcName;
                        item.indicatorItem = item.mainTarget.indicatorItem.indicatorItemName;
                    });
                    res.data.sort((a, b) => b.id - a.id);
                    this.itemList = res.data;
                })
                .catch((err) => {
                    this.loadItems = false;
                    this.showToast("Getting Target went wrong!", "error");
                });
        },
        async createMixItem(props) {
            this.pageLoader(true);
            this.$refs['resource-update'].createMixItem(props);
            this.pageLoader(false);
        },
        getItemCategory() {
            this.$bvModal.show("item-category-modal");
        },
        dropItemCat(data) {
            this.itemCategory = data;
            this.item.itemCategoryId = data.id;
        },
        async getAllAPI() {
            this.selectAllAPI = true;
            this.targetData = [];
            this.tableBusy = true;
            this.selectedTarget = null;
            this.showTarget = false;
            this.apiName = 'All';
            this.selectedItem = 0;
            if (!this.selectedOPCR) {
                return this.tableBusy = false;
            }
            await this.$store
                // .dispatch("api/GetApiByOpcr", this.selectedOPCR.id)
                .dispatch("api/GetAllApis", this.selectedOPCR.id)
                .then((res) => {
                    this.tableBusy = false;
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    res.data.forEach((x) => {
                        x.sort = 3;
                        if (x.type.toLowerCase().includes('strategic')) {
                            x.sort = 1;
                        } else if (x.type.toLowerCase().includes('core')) {
                            x.sort = 2
                        }
                        x.showApis = x.apis.length;
                        x.filterKey = `${x.target}`;
                        x.apis.map(item => {
                            item.showAttachments = false;
                            item.attachmentLoading = false;
                            item.addDocu = false;
                            item.fileSearch = "";
                            item.attachments = [];
                            item.totalResources = this.formatCurrency(item.total);
                            item.selected = false;
                            item.targetId = x.targetId;
                            x.filterKey += ` ${item.name}`;
                            item.filterKey = `${x.target} ${item.name}`;
                        }).sort((a, b) => a.name.localeCompare(b.name))
                    });
                    this.targetData = res.data.sort((a, b) => a.target?.localeCompare(b.target)).sort((a, b) => a.sort - b.sort);
                })
                .catch((err) => {
                    console.log(err)
                    this.tableBusy = false;
                    this.showToast("Something went wrong!", "error");
                });
        },
        closeTargetPopOver() {
            this.showTarget = false;
            this.startTransferAPI = false;
        },
        printPPMP(type) {
            this.$refs.printOpt.putOptions({
                apiUrl: type == 2 ? 'api/Report/Procurement/PPMP/Report' : "api/Report/My/PPMP/OPCR",
                routeVariables: [this.selectedOPCR.id],
            });
            this.$bvModal.show("print-options-modal");
        },
        printTPMS() {
            this.$refs.printOpt.putOptions({
                apiUrl: "api/Report/Planning/TPMS",
                routeVariables: [this.selectedOPCR.id],
            });
            this.$bvModal.show("print-options-modal");
        },
        printPPMPByApi({ id, type }) {
            this.$refs.printOpt.putOptions({
                apiUrl: type == 2 ? 'api/Report/Procurement/PPMP/Api/Report' : "api/Report/My/PPMP/API",
                routeVariables: [id],
            });
            this.$bvModal.show("print-options-modal");
        },
        selectOPCR(opcr) {
            this.selectedOPCR = cloneDeep(opcr);
            this.showOPCR = false;
            if (this.selectAllAPI) {
                this.getAllAPI();
            } else {
                this.getAPIbyOPCRandTarget();
            }
        },
        closeUpdateModal(data) {
            let index = this.resourceItems.findIndex(x => x.id == data.id);
            this.resourceItems[index].totalQuantity = data.quantity;
            this.resourceItems[index].totalWithInflation = data.amount;
        },
        successUpdateResource(data) {
            let index = this.resourceItems.findIndex(x => x.id == data.id);
            this.resourceItems.splice(index, 1, data);
        },
        successAddResource(data) {
            if (data.mixParentId && data.mixParentId > 0) {
                let filterChilds = this.resourceItems.filter(x => x.mixParentId == data.mixParentId);
                if (filterChilds.length > 0) {
                    let index = this.resourceItems.findIndex(x => x.id == filterChilds[filterChilds.length - 1].id);
                    this.resourceItems.splice(index + 1, 0, data);
                } else {
                    let index = this.resourceItems.findIndex(x => x.id == data.mixParentId);
                    this.resourceItems.splice(index + 1, 0, data);
                }
            } else {
                this.resourceItems.push(data);
            }
        },
        updateItemColumn(data) {
            if (data.type === 'deduct') {
                let rowItem = this.resourceItems.find((e) => e.id == data.id)
                rowItem[data.column] -= data.value;
                if (rowItem.mixParentId > 0) { this.recalculateMixTotals(rowItem.mixParentId) }
            } else if (data.type === 'add') {
                this.resourceItems.find((e) => e.id == data.id)[data.column] += data.value;
            } else {
                this.resourceItems.find((e) => e.id == data.id)[data.column] = data.value;
            }
        },
        recalculateMixTotals(id) {
            let sum = 0;
            this.resourceItems.forEach((item) => {
                if (item.mixParentId == id) {
                    sum += parseFloat(item.totalWithInflation);
                }
            });
            let mixItem = this.resourceItems.find((e) => e.id == id);
            mixItem.remaining = mixItem.totalWithInflation - sum;
        },
        updateTotals(data) {
            if (this.selectAllAPI) {
                let apiIndex = this.selectedAllTarget.apis.findIndex((e) => e.id == data.apiId)
                this.selectedAllTarget.apis[apiIndex].totalResources = this.formatCurrency(cloneDeep(this.totalResourceItemAmt()));
                this.selectedAllTarget.apis[apiIndex].totalCurrency = this.formatCurrency(this.totalResourceItemAmt());
            } else {
                let apiIndex = this.targetData.findIndex((e) => e.id === data.apiId);
                this.targetData[apiIndex].totalResources = cloneDeep(this.totalResourceItemAmt());
                this.targetData[apiIndex].totalCurrency = this.formatCurrency(this.totalResourceItemAmt());
            }
        },
        updatePackage(id) {
            this.itemLoading = true;
            this.resourceItems = [];
            this.getResourceDetails(id);
        },
        addNewItem() {
            this.budgetTransferModal = true;
            this.$refs['resource-update'].addNewItem();
        },
        transferToMother(x) {
            this.itemToTransfer = cloneDeep(x);
            this.$bvModal.show('transfer-mother-modal');
        },
        async onTransferToMother() {
            let data = cloneDeep(this.itemToTransfer);
            data.mixParentId = this.motherID;
            this.submitted = true;
            this.$v.motherID.$touch();
            if (this.$v.motherID.$invalid) {
                return;
            }
            await this.$store
                .dispatch("apiresource/UpdatePPMPItem", data)
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    let index = this.resourceItems.findIndex((e) => e.id == data.id);
                    let motherIndex = this.resourceItems.findIndex((e) => e.id == this.motherID);
                    if (this.itemToTransfer.mixParentId && this.itemToTransfer.mixParentId > 0) {
                        this.resourceItems.find((e) => e.id == this.itemToTransfer.mixParentId).remaining += data.totalWithInflation;
                    }
                    if (motherIndex > -1) {
                        this.resourceItems.splice(index, 1);
                        this.resourceItems.splice(motherIndex, 0, data);
                        this.resourceItems[motherIndex].remaining -= data.totalWithInflation;
                    }
                    this.$bvModal.hide('transfer-mother-modal');
                    this.showToast("Successfully transferred!", "success");
                })
                .catch((e) => {
                    this.showToast("Something went wrong!", "error");
                    this.submitted = false;
                });
        },
        filterApiCards(apis) {
            let data = apis;
            if (this.filter && this.filter.trim !== '') {
                data = data.filter(x => {
                    return x.filterKey.toUpperCase().includes(this.filter.toUpperCase());
                })
            }
            return data;
        },
        showCart() {
            this.$bvModal.show('cart-items-modal');
        },
        selectCartItem(item) {
            let dataItem = cloneDeep(item.item);
            dataItem.cartItemId = item.id;
            this.$refs['resource-update'].dropItem(dataItem, true);
            this.$bvModal.hide('cart-items-modal');
        },
        removeFromCart(id) {
            this.$store
                .dispatch("deliveryunititemcart/DeleteDeliveryUnitItemCart", id)
                .then((res) => {
                    if (res.data.error) {
                        return;
                    }
                    let index = this.carts.findIndex(x => x.id == id);
                    this.carts.splice(index, 1);
                })
                .catch((err) => {
                    return;
                });
        },
        changeIsBigProject() {
            this.apiType = "";
            this.form.apiTypeId = 0;
            this.form.apiType = null;
        },
        deleteAllItems() {
            Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#dc3545",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, delete all items!",
            }).then(async (result) => {
                if (result.value) {
                    let errors = 0;
                    for await (const item of this.resourceItems) {
                        await this.$store
                            .dispatch("apiresource/DeletePPMPItem", item.id)
                            .then((res) => {
                                if (res.data.error) {
                                    errors++;
                                    return;
                                }
                            })
                            .catch((err) => {
                                errors++;
                                return;
                            });
                    }
                    if (errors > 0) {
                        this.showToast("Some items cannot be deleted!", "error");
                    } else {
                        this.resourceItems = [];
                        this.showToast("All items successfully deleted!", "success");
                    }
                }
            });
        }
    }
};
</script>

<template>
    <Layout @changeCycle="changeCycle" @changeDU="changeDU">
        <PageHeader :title="title" :items="items" />
        <profile-cropper ref="profileCropper" @crop-picture="cropData"></profile-cropper>
        <ResourceUpdate ref="resource-update" :budgetTransferModal="budgetTransferModal" :updatableMixOption="false"
            :selectedApiId="selectedApiId" :selectedTransfer="selectedTransfer" :carts="carts"
            @close-update="closeUpdateModal" @update-item="successUpdateResource" @add-item="successAddResource"
            @specific-item-update="updateItemColumn" @update-package="updatePackage" @update-totals="updateTotals"
            @recalculate-totals="recalculateMixTotals" @refresh-all="goToPPMP(selectedApiCopy)" @view-cart="showCart"
            @remove-from-cart="removeFromCart" />
        <b-modal id="modal-standard" :title="modalTitle" size="md" title-class="font-18" hide-footer
            no-close-on-backdrop no-close-on-esc>
            <form @submit.prevent="onCreate" class="needs-validation" ref="apiForm">
                <b-row>
                    <div class="col-md-12">
                        <div :class="{ 'border border-primary position-relative mb-3': form.isCatchUp }">
                            <div :class="{ isCatchup: form.isCatchUp }" class="mb-3">
                                <input autocomplete="off" class="form-check-input" type="checkbox" id="isCatchUp"
                                    v-model="form.isCatchUp" />&nbsp;&nbsp;
                                <label class="form-check-label" for="isCatchUp">
                                    Is CatchUp?
                                </label>
                            </div>
                            <div class="mt-3 mx-2 mb-2" v-if="form.isCatchUp">
                                <div class="mb-3">
                                    <label for="previousWork">Previous Work</label>
                                    <b-input-group>
                                        <template #append>
                                            <b-button @click="getWork" variant="outline-info">
                                                <i class="mdi  mdi-clipboard-text-search-outline"></i>
                                            </b-button>
                                        </template>
                                        <input autocomplete="off" type="text" disabled
                                            placeholder="Search Previous Work..." class="form-control"
                                            :class="{ 'is-invalid': submitted && $v.previousWork.name.$error }"
                                            v-model="previousWork.name" />
                                    </b-input-group>
                                    <div v-if="submitted && $v.previousWork.name.$error" class="invalid-feedback">
                                        <span v-if="!$v.previousWork.name.required">This value is required.</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="mb-3">
                        <label for="name">API Name
                        </label>
                        <textarea autocomplete="off" id="name" rows="5" v-model="form.name"
                            placeholder="Enter API Name..." class="form-control"
                            :class="{ 'is-invalid': submitted && $v.form.name.$error }"></textarea>
                        <div v-if="submitted && $v.form.name.$error" class="invalid-feedback">
                            <span v-if="!$v.form.name.required">This value is required.</span>
                        </div>
                    </div>
                    <div class="mb-3">
                        <label for="description">Expected Output
                        </label>
                        <textarea autocomplete="off" id="name" rows="3" v-model="form.expectedOutput"
                            placeholder="Enter Expected Output..." class="form-control"></textarea>
                    </div>
                    <div class="mb-3">
                        <label for="description">Others Involved (Optional)
                        </label>
                        <textarea autocomplete="off" id="name" rows="3" v-model="form.description"
                            placeholder="Enter Others Involved..." class="form-control"></textarea>
                    </div>
                    <div class="mb-3" v-if="$store.state.data.selectedCampus.isExternal">
                        <label for="description">Schedule
                        </label>
                        <textarea autocomplete="off" id="name" rows="3" v-model="form.schedule"
                            placeholder="Enter Schedule..." class="form-control"></textarea>
                    </div>
                    <div class="mb-2">
                        <div class="form-check form-checkbox-outline form-check-success mb-0">
                            <input type="checkbox" id="isBigProject" class="form-check-input"
                                v-model="form.isBigProject" @change="changeIsBigProject" />
                            <label for="isBigProject" class="form-check-label">Special Project</label>
                        </div>
                    </div>
                    <div class="mb-3" v-if="form.isBigProject">
                        <label for="apiTypeId">API Type</label>
                        <b-input-group>
                            <template #append>
                                <b-button @click="getApiType" variant="outline-info">
                                    <i class="mdi mdi-clipboard-text-search-outline"></i>
                                </b-button>
                            </template>
                            <input autocomplete="off" type="text" disabled placeholder="Search API Type..."
                                class="form-control" :class="{ 'is-invalid': submitted && $v.apiType.$error }"
                                v-model="apiType" />
                        </b-input-group>
                        <div v-if="submitted && $v.apiType.$error" class="invalid-feedback">
                            <span v-if="!$v.apiType.required">This value is required.</span>
                        </div>
                    </div>
                </b-row>
                <div class="d-flex mb-2">
                    <div class="form-check form-checkbox-outline form-check-success mb-0">
                        <input type="checkbox" id="addressClimateChange" class="form-check-input"
                            v-model="form.addressingClimateChange" />
                        <label for="addressClimateChange" class="form-check-label">Addressing Climate Change</label>
                    </div>
                </div>
                <div class="mb-2 ms-3" v-if="form.addressingClimateChange">
                    <b-form-radio-group v-model="form.climateAddress" :options="climateAddreses" name="status-options"
                        plain>
                    </b-form-radio-group>
                </div>
                <div class="modal-footer">
                    <button type="submit" class="
                            btn btn-primary
                        ">
                        Save changes
                    </button>
                    <button type="button" class="btn btn-link" @click="hideModal">
                        Close
                    </button>
                </div>
            </form>
        </b-modal>
        <b-modal id="transfer-mother-modal" title="Transfer to Mother" size="sm" title-class="font-18" hide-footer
            no-close-on-backdrop>
            <form @submit.prevent="onTransferToMother" class="needs-validation" ref="fcForm">
                <div class="mb-3">
                    <label for="motherID"> Mother ID </label>
                    <input autocomplete="off" id="motherID" type="text" v-model="motherID"
                        placeholder="Enter Mother ID..." class="form-control"
                        :class="{ 'is-invalid': submitted && $v.motherID.$error }" />
                    <div v-if="submitted && $v.motherID.$error" class="invalid-feedback">
                        <span v-if="!$v.motherID.required">This value is required.</span>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="submit" class="btn btn-primary">
                        Save changes
                    </button>
                    <button type="button" class="btn btn-link" @click="$bvModal.hide('transfer-mother-modal')">
                        Close
                    </button>
                </div>
            </form>
        </b-modal>
        <div class="row position-relative">
            <div class="col-12">
                <div v-if="frontPage">
                    <OPCRView ref="opcrDefault" opcrType="actual" :department="false" :apiName="apiName"
                        :selectedItem="selectedItem" :selectedTransfer="selectedTransfer" :selectedOPCR="selectedOPCR"
                        :selectAllAPI="selectAllAPI" :selectedTarget="selectedTarget" :opcrs="opcrs"
                        :targetData="targetData" :itemList="itemList" :tableBusy="tableBusy"
                        :startSelection="startSelection" :loadItems="loadItems" @getAllAPI="getAllAPI"
                        @selectOPCR="selectOPCR" @closeTargetPopOver="closeTargetPopOver"
                        @selectIndicatorItem="selectIndicatorItem" @goToPPMP="goToPPMP" @goToPPMPAll="goToPPMPAll"
                        @addApi="addApi" @deleteItem="deleteItem" @deleteItemAll="deleteItemAll"
                        @updateItem="updateItem" @updateItemAll="updateItemAll" @printDULIB="printDULIB"
                        @printPPMP="printPPMP" @printPPMPByApi="printPPMPByApi" @printWFP="printWFP"
                        @printOPCR="printOPCR" @selectTransferApi="selectTransferApi" />
                </div>
                <div v-else>
                    <ItemsView :loading="itemLoading" :planning="false" :department="false" :selectedApi="selectedApi"
                        :selectedOPCR="selectedOPCR" :selectedTransfer="selectedTransfer" :tableData="resourceItems"
                        @returnToApi="returnToApi" @addItem="addNewItem" @updateItem="updateResourceItem"
                        @transferItem="transferItem" @deleteItem="deleteResourceItem" @postWork="postWork"
                        @resubmitItem="resubmitItem" @viewItemLogs="viewItemLogs" @updateMixItem="updateMixResourceItem"
                        @transferToMother="transferToMother" @createMixItem="createMixItem"
                        @generatePPMP="printPPMPByApi({ id: selectedApi.id, type: $event })"
                        @deleteAllItems="deleteAllItems" />
                </div>
            </div>
        </div>
        <api-type @dropData="dropType($event)"></api-type>
        <api-resource-logs ref="itemlog"></api-resource-logs>
        <api-logs ref="apilog"></api-logs>
        <import-preplanning ref="preplanning" @dropData="dropImports"></import-preplanning>
        <import-api ref="importapi" @dropData="dropImportedApi"></import-api>
        <back-log-modal ref="backlog" @dropData="dropWork($event)"></back-log-modal>
        <print-options ref="printOpt"></print-options>
        <div v-if="selectedTransfer.id">
            <div class="position-fixed p-4" style="top: 125px; left: 50%; transform: translateX(-50%)">
                <div>
                    <span class="bg-success badge p-2 font-size-14">Transfer Item:<u>
                            {{ itemNamesFromSelected }}</u></span>
                    <div class="text-center">
                        <small>Select API & Budget Item to Proceed</small>
                    </div>
                </div>
            </div>
            <button type="button" class="btn btn-warning position-fixed" style="bottom: 2%; right: 3%"
                @click="cancelTransfer">
                <i class="bx bx-x me-1"></i>Cancel Transfer Items
            </button>
        </div>
        <b-modal id="cart-items-modal" title="Cart Items" size="lg" title-class="font-18" hide-footer
            no-close-on-backdrop>
            <CartItems :items="carts" :withActions="false" @select-item="selectCartItem" />
        </b-modal>
    </Layout>
</template>
